// LayerPopupCtrl.ts
import { type Viewer } from 'cesium'
import { Popup } from 'cesium-extends'
import { createApp, type Component } from 'vue'

/** 弹窗控制器 */
export class LayerPopupCtrl {
  private static instance: LayerPopupCtrl | null = null;

  private constructor() {
    // 初始化代码
  }

  public static getInstance(): LayerPopupCtrl {
    if (!LayerPopupCtrl.instance) {
      LayerPopupCtrl.instance = new LayerPopupCtrl();
    }
    return LayerPopupCtrl.instance;
  }

  popupMap = new Map<string | number, { popup: Popup; destroy(): void }>()

  popup(payload: {
    viewer: Viewer
    id: string | number
    lnglat: [number, number]
    Com: Component<{ close(): void }>
    properties?: any
  }) {
    const viewerContainer = payload.viewer.container
    const element = document.createElement('div')
    element.className = 'cesium-popup'
    const destroyFn = () => {
      if (!app || !popup) return
      app.unmount()
      viewerContainer.removeChild(element)
      popup.destroy()
      this.popupMap.delete(payload.id)
    }
    const app = createApp(payload.Com, { properties: payload.properties, close: destroyFn })
    viewerContainer.appendChild(element)
    app.mount(element)
    this.popupMap.get(payload.id)?.destroy()
    const popup = new Popup(payload.viewer, {
      position: payload.lnglat,
      offset: [0, -25],
      element,
    })
    this.popupMap.set(payload.id, {
      popup,
      destroy: destroyFn,
    })
  }

  closeAll() {
    this.popupMap.forEach((entry) => entry.destroy())
    this.popupMap.clear()
  }
}